import React, { FC } from 'react'

import dayjs from 'dayjs'

import { CircleIconButton } from '@style-port/roov-ui-components-react'
import { Icon } from 'src/components/atoms'

type Props = {
  selectedYear: number
  oldestYear: number
  onClickPrevYear: () => void
  onClickNextYear: () => void
  className?: string
}

export const ChartChangeYearButtons: FC<Props> = ({
  selectedYear,
  oldestYear,
  onClickPrevYear,
  onClickNextYear,
  className,
}) => {
  return (
    <div className={className}>
      <div className="tw-full-justify">
        <CircleIconButton
          buttonType="standard-primary"
          disabled={selectedYear === oldestYear}
          // TODO: ui-components側でdisabledの場合に押下出来ない処理を追加後 onClick の処理を見直す
          onClick={() => !(selectedYear === oldestYear) && onClickPrevYear()}
        >
          <Icon size="--r1" path="chevron-left/soft/line" />
        </CircleIconButton>

        <CircleIconButton
          buttonType="standard-primary"
          disabled={selectedYear === dayjs().year()}
          // TODO: ui-components側でdisabledの場合に押下出来ない処理を追加後 onClick の処理を見直す
          onClick={() => !(selectedYear === dayjs().year()) && onClickNextYear()}
        >
          <Icon size="--r1" path="chevron-right/soft/line" />
        </CircleIconButton>
      </div>
    </div>
  )
}
